<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <h4 style="margin-left: 10px">Customer</h4>
        </div>
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button
            :to="{ name: 'master-customer-add'} "
            class="btn mb-4 md:mb-0 mr-1"
            icon="add"
            v-if="hasAccess('create')"
          >Add</vs-button>
          <vs-button
            :to="{ name: 'master-customer-view', params: {id: selectedId} }"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="removeItem"
            icon="delete"
            :disabled="selectedId ? false : true"
            v-if="hasAccess('delete')"
          >Delete</vs-button>
          <vs-button class="mb-4 md:mb-0 mr-1" @click="showFilter = true" icon="filter_list">Filter</vs-button>
          <vs-dropdown>
            <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="getTemplate" v-if="hasAccess('create')">Template</vs-dropdown-item>
              <vs-dropdown-item @click="$refs.file.click()" v-if="hasAccess('create')">Upload</vs-dropdown-item>
              <input type="file" ref="file" style="display: none" v-on:change="uploadExcel" />
              <vs-dropdown-item @click="exportExcel({ endpoint: 'master/customers/report/exportexcel', name: 'customer', filter: filter })">Export</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="customers"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
      ></ag-grid-vue>
      <p class="text-right">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
      <vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
        <div class="con-exemple-prompt">
          <vs-input label="BP ID" v-model="filter.bp_id" class="mb-2 w-full" />
          <vs-input label="Customer Name" v-model="filter.name" class="mb-2 w-full" />
          <vs-input label="Address 1" v-model="filter.address_1" class="mb-2 w-full" />
          <vs-input label="Address 2" v-model="filter.address_2" class="mb-2 w-full" />
          <vs-input label="Phone" v-model="filter.phone" class="mb-2 w-full" />
          <vs-input label="Email" v-model="filter.email" class="mb-2 w-full" />
          <vs-input label="PIC" v-model="filter.pic" class="mb-2 w-full" />
          <label for class="vs-input--label">Area</label>
          <vs-select
              class="selectExample mb-2"
              v-model="filter.area_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, area)"
          >
              <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
          </vs-select>
          <label for class="vs-input--label">Sub Area</label>
          <vs-select
              class="selectExample mb-2"
              v-model="filter.sub_area_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, area)"
          >
              <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
          </vs-select>
        </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import { saveAs } from "file-saver";

export default Vue.extend({
  template: `
        <span>
            <button style="height: 20px; line-height: 0.5" v-on:click="invokeParentMethod" class="btn btn-info">Invoke Parent</button>
        </span>
    `,
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      columnApi: null,
      // columnDefs: null,
      rowData: null,
      context: null,
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      customers: [],
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      selectedId: null,
      isLoading: false,
      showFilter: false,
      filter: {
        bp_id: '',
        name: '',
        address_1: '',
        address_2: '',
        phone: '',
        email: '',
        pic: '',
        area_id: null,
        sub_area_id: null,
        client_id: this.$store.state.user.user.client_id,
      },
      areas: [],

      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0,
      area: {
          data: [],
          loading: false,
          endpoint: 'master/areas',
          objectKey: 'village'
      },
    };
  },
  watch: {

    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    invokeParentMethod() {
      this.params.context.componentParent.methodFromParent(
        `Row: ${this.params.node.rowIndex}, Col: ${this.params.colDef.headerName}`
      );
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    removeItem() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this customer?",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      this.isLoading = true;
      this.$http
        .delete("master/customers/" + this.selectedId + "/destroy")
        .then(res => {
          this.$vs.notify({
            color: "success",
            title: "Customer deleted",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected customer was successfully deleted"
          });
          this.fetchData();
        })
        .catch(error => this.handleError(error))
    },
    refreshData() {
      this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
    },
    fetchData() {
      this.isLoading = true;
      this.$http
        .post("master/customers?page=" + this.currentPage, this.filter)
        .then(resp => {
          this.customers = resp.data.data;
          this.totalPage = resp.data.last_page;
          this.currentPage = this.currentPage;
          this.dataTotal = resp.data.total;
          this.dataFrom = resp.data.from;
          this.dataTo = resp.data.to;
          this.isLoading = false;
        })
        .catch(resp => {
            this.isLoading = false;
            this.$vs.dialog({
              type: "confirm",
              color: "danger",
              title: "Server Error",
              text: "Try again?",
              accept: () => {
                this.refreshData();
              },
              acceptText: "Yes",
              cancelText: "No"
            });
            return;
        });
    },
    viewData() {
      this.$router.push({
        name: "master-customer-view",
        params: {
          id: this.selectedId
        }
      });
    },
    filterData() {
      this.currentPage = 1;
      this.fetchData();
    },
    getTemplate() {
      this.isLoading = true;
      this.$http
        .get("master/customers/report/gettemplate", {
          responseType: "blob"
        })
        .then(response => {
          this.isLoading = false;
          saveAs(response.data, "Customers-template.xlsx");
        });
    },
    uploadExcel(e) {
      let file = e.target.files[0];
      let form = new FormData();
      form.append("file", file);
      this.isLoading = true;
      this.$http
        .post("/master/customers/report/importexcel", form, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(resp => {
          this.isLoading = false;
          this.fetchData();
          setTimeout(() => {
            this.$vs.notify({
              color: "success",
              title: "Upload Success",
              text: "Upload Customers Successfully"
            });
          }, 500);
        })
        .catch(error => this.handleError(error));
    },
    fetchDropdown() {
      this.isLoading = true;
      return Promise.all([
        this.$http.post("master/areas"),
      ])
        .then(
          this.$http.spread((areas) => {
            areas.data.data.map(area => {
              if(this.area.data.findIndex(a => a.id == area.id) === -1) {
                this.area.data.push(area)
              }
            })
          })
        )
    }
  },
  mounted() {
    this.fetchDropdown().then(() => this.fetchData())
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  beforeMount() {
    this.columnDefs = [
      // {
      //   headerName: "Customer ID",
      //   field: "id",
      //   width: 100,
      //   colId: "params"
      // },
      {
        headerName: "BP ID",
        field: "bp_id",
        width: 120,
      },
      {
        headerName: "Name",
        field: "name",
        width: 120
      },
      {
        headerName: "Address 1",
        field: "address_1",
        width: 120
      },
      {
        headerName: "Address 2",
        field: "address_2",
        width: 120
      },
      {
        headerName: "Client Code",
        field: "client_code",
        width: 120
      },
      {
        headerName: "Client Type",
        field: "client_type",
        width: 120
      },
      {
        headerName: "PIC",
        field: "pic",
        width: 120
      },
      {
        headerName: "Phone",
        field: "phone",
        width: 120
      },
      {
        headerName: "Email",
        field: "email",
        width: 120
      },
      {
        headerName: "Area",
        field: "area",
        width: 120
      },
      {
        headerName: "Sub Area",
        field: "sub_area",
        width: 120
      },
      {
        headerName: "Location",
        field: "location",
        width: 120
      }
    ];
    this.gridOptions.getRowHeight = function(params) {
        return 35;
    }
  }
});
</script>







